import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import { useApiFetch } from '../../shared/api'

export interface UpcomingHuntDto {
  id: string
  huntName: string
  groupId: string
  groupName: string
  startTime: string
  endTime: string | null
  participantCount: number
  status: string
  huntableGames: string[]
  isOrganizer: boolean
  invitedBy: string | null
  inviteStatus: string | null
  /** When the invitation was last sent; null or absent when there is none. */
  invitedAt?: string | null
}

export interface UpcomingHuntsResponse {
  hunts: UpcomingHuntDto[]
}

export function useUpcomingHunts() {
  const call = useApiFetch()
  const { state } = useAuth()
  const uid = state.status === 'signed-in' ? state.user.uid : undefined
  return useQuery({
    queryKey: ['clubhouse', 'me', 'hunts', 'upcoming', uid],
    queryFn: () => call<UpcomingHuntsResponse>('/clubhouse/me/hunts/upcoming'),
    enabled: !!uid,
    staleTime: 60 * 1000,
  })
}
